import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import workforceNotificationsQueryParameters, {
	type WorkforceNotificationsQuery,
} from './__generated__/WorkforceNotificationsQuery.graphql.ts';

type WorkforceNotificationsEntryPointComponent = EntryPointComponent<
	{ shiftNotificationPreferencesQuery: WorkforceNotificationsQuery },
	{},
	{},
	{}
>;

export const workforceNotificationsEntryPoint: EntryPoint<
	WorkforceNotificationsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<WorkforceNotificationsEntryPointComponent>(
		/* webpackChunkName: "async-personal-settings-workforce-notifications" */ './WorkforceNotifications.tsx',
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			shiftNotificationPreferencesQuery: {
				parameters: workforceNotificationsQueryParameters,
				variables: { cloudId: tenantContext.cloudId },
			},
		},
	}),
});
